<template>
  <div class="input-text d-block">
    <label v-if="label">{{ label }}
      <a v-if="link" href="#" @click="$emit('linkAction')" style="float:right">{{link}}</a>
      <span v-if="rules.required" class="warning-color">*</span>
    </label>
    <textarea
      :class="{required: shouldShowError}"
      class="editor-box"
      :value="value"
      :disabled="disabled"
      :placeholder="placeholder"
      :style="textAreaStyle"
      @keydown="$emit('change', $event.target.value)"
      @focus="$emit('focus')"
      @input="$emit('input', $event.target.value)"
      oninput="validity.valid||(value='');" />
    <span v-if="shouldShowError" class="warning-color validation-span" style="font-size: 12px;">{{ $t(errorMsg) }} {{ errorMsgAdditional }}</span>
  </div>
</template>

<script>
import rules from '@/mixins/rules';

export default {
  name: 'textArea',
  mixins: [rules],
  props: {
    placeholder: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    value: {
      type: [String, Number, Date],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    link: {
      type: String,
      default: '',
    },
    textAreaStyle: {
      type: String,
      default: '',
    },
  },
}
</script>

<style scoped>

</style>
